import { ParamsSetCookie } from './types'

const setCookie = ({ name, value, days, unixTimestamp }: ParamsSetCookie): void => {
  if (!navigator.cookieEnabled) {
    console.warn('Cookies are disabled on this browser')
    return
  }

  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  if (unixTimestamp) {
    const expiryDate = new Date(parseInt(unixTimestamp.toString()))
    expires = '; expires=' + expiryDate.toUTCString()
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

const getCookie = (name: string): string | null => {
  if (!navigator.cookieEnabled) {
    console.warn('Cookies are disabled on this browser')
    return null
  }

  const pair = document.cookie.match(new RegExp(name + '=([^;]+)'))
  return pair ? pair[1] : null
}

const deleteCookie = (name: string): void => {
  if (!navigator.cookieEnabled) {
    console.warn('Cookies are disabled on this browser')
    return
  }

  document.cookie = name + '=' + ';expires=Thu, 01 Jan 1970 00:00:01 GMT'
}

export { setCookie, getCookie, deleteCookie }
